<template>
  <div id="HolterRequest">
    <section>
      <div id="container-center">
        <form>
        <h1 style="" class="title has-text-centered printTarget">ホルター心電図配送ｻｰﾋﾞｽ申込み</h1>
        <div>
          <b-steps v-model="activeStep" :animated="true" :rounded="true" :has-navigation="false" label-position="bottom">
            <b-step-item step="1" label="利用規約" icon="comment-alert-outline" v-if="needAgree">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面 </b-button>
                  <b-button class="is-primary" style="float: right" icon-right="chevron-double-right" :disabled="!isChecked" @click.prevent="Forward">次へ</b-button>
                  <span>以下の利用規約に同意のうえ、申込みを行ってください。</span>
                </div>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">利用規約</span>
                  <table>
                    <tr><td><textarea readonly class="cautionArea noresize" v-model="agreement" /></td></tr>
                    <tr>
                        <td>
                          <div style="text-align: center;">
                            「<a :href="getUrlRentalCondition()" target="_blank" rel="noopener noreferrer">レンタルの一般条件</a>」は<a :href="getUrlRentalCondition()" target="_blank" rel="noopener noreferrer" style="font-weight: bold;color:yellowgreen">こちら</a>を参照してください。 「<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer">プライバシー規則</a>」は<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer" style="font-weight: bold;color:yellowgreen">こちら</a>を参照してください。
                          </div>
                       </td>
                    </tr>
                    <tr><td><div style="text-align: center;"></div></td></tr>
                    <tr><td><div style="text-align: center;"><b-checkbox class="cstmCheckBox" v-model="isChecked" :disabled="!canAgree">利用規約に同意のうえ、申込みを行う。</b-checkbox></div></td></tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="2" label="基本情報" icon="clipboard-edit-outline">
              <div id="item-contens">
                <div class="request-title">
                  <b-button v-if="needAgree" class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <b-button v-else class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面 </b-button>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" :disabled="!isHospitalAgree" @click.prevent="Forward">次へ</b-button>
                  <span>申込み内容を入力してください。</span>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>医療機関名<span class="require" v-if="isDealer || isHonsha || isAdmin || isSalesOffice"/></th>
                      <td>
                        <template v-if="isDealer || isHonsha || isAdmin || isSalesOffice">
                          <input type="text" style="width:730px;height:27px;" v-model="reqParams.hospitalName" class="2" name="医療機関名" validate="required" disabled />
                          <b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">医療機関選択</b-button>
                        </template>
                        <template v-else>{{reqParams.hospitalName}}</template>
                      </td>
                    </tr>
                    <tr><th>医師名</th><td><input type="text" v-model="reqParams.doctorName" maxlength="105"/></td></tr>
                    <tr><th>事務担当者名</th><td><input type="text"  v-model="reqParams.clerkName" maxlength="100"/></td></tr>
                    <tr v-if="isHonsha || isAdmin || isSalesOffice"><th>コメント</th><td>{{reqParams.note}}</td></tr>
                    <template v-if="isDealer">
                      <tr><th>医療機関メールアドレス</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.isResultMailSend">解析結果のダウンロードURLを医療機関にメールで通知する。</b-checkbox></td></tr>
                      <tr v-if="reqParams.isResultMailSend"><th></th><td><input type="text" v-model="reqParams.hospitalMail" maxlength="256" placeholder="例）example@example.com" class="2" name="医療機関メールアドレス" validate="mail|required"></td></tr>
                    </template>
                    <tr><th>機種<span class="require" name="item_step2" id="model"/></th><td><select id="model" class="2" name="機種" validate="required" @change="changeModel" v-model="reqParams.model"><option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option></select></td></tr>
                    <tr>
                      <th>最短出荷日</th>
                      <td>
                        <p>{{ earliestShippingDate }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        <p style="font-size: 14px;">
                          現時点での最短出荷日の目安となります。<br>
                          確定出荷日は申込完了時の画面でご確認ください。
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th>検査期間<span class="require" name="item_step2" id="period"/></th>
                      <td>
                        <select v-if="!reqParams.demo" v-model="reqParams.inspectionPeriod" :disabled="!reqParams.hospitalName || inspectionPeriodList.length <= 1" class="2" name="検査期間" validate="required">
                          <option v-for="inspectionPeriod in inspectionPeriodList" :value="inspectionPeriod.value" :key="inspectionPeriod.value">{{ inspectionPeriod.label1 }}</option>
                        </select>
                        <select v-if="reqParams.demo" v-model="reqParams.inspectionPeriod" :disabled="!reqParams.hospitalName || inspectionPeriodList.length <= 1" class="2" name="検査期間" validate="required">
                          <option v-for="inspectionPeriod in inspectionPeriodList" :value="inspectionPeriod.label3" :key="inspectionPeriod.label3">{{ inspectionPeriod.label1 }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr v-if="reqParams.hospitalName && inspectionPeriodList.length <= 1"><th></th><td>現在、ご契約済の検査期間はございません。営業担当にお問い合わせください。</td></tr>
                    <tr v-if="false">
                      <th>解析オプション（有料）<span class="require" name="item_step2" id="period"/></th>
                      <td>
                        <select v-model="reqParams.analysisOption" class="2" name="解析オプション（有料）" @change="changedAnalysisOption" validate="required">
                          <option v-for="analysisOption in analysisOptionList" :value="analysisOption.value" :key="analysisOption.value">{{ analysisOption.label1 }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr v-if="reqParams.judgmentFlag"><th>判定医</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.judgment">前回と違う判定医に依頼する。</b-checkbox></td></tr>
                    <tr><th>機器配送先<span class="require"/></th><td>
                      <div class="block">
                        <b-radio class="td_radio" name="target"  v-model="reqParams.delivaryTarget" native-value="home">患者宅に配送する</b-radio>
                        <b-radio class="td_radio" name="target"  v-model="reqParams.delivaryTarget" native-value="hospital">医療機関に配送する</b-radio>
                      </div></td>
                    </tr>
                    <tr v-if="reqParams.delivaryTarget== 'hospital' && !atLaunchHidden.hiddenFlag">
                      <th>リードワイヤーアダプター<span class="require" name="item_step2" id="leadWireAdapter"/></th>
                      <td>
                        <div class="block">
                          <b-radio class="td_radio" name="リードワイヤーアダプター" v-model="reqParams.leadWireAdapter" :native-value="true">必要</b-radio>
                          <b-radio class="td_radio" name="リードワイヤーアダプター" v-model="reqParams.leadWireAdapter" :native-value="false">不要</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>睡眠検査</th>
                      <td><b-checkbox class="cstmCheckBox" v-model="reqParams.hstRequestFlag" :disabled="!(reqParams.hospitalName && (reqParams.demo || this.hstModelList.length > 1)) " @input="hstChangeModel">睡眠検査(HST)も併せて申込む</b-checkbox></td>
                    </tr>
                    <tr v-if="reqParams.hospitalName && this.hstModelList.length <= 1 && !reqParams.demo"><th></th><td>睡眠検査（ウォッチパット300）は未契約です。営業担当にお問い合わせください。</td></tr>
                    <tr v-if="reqParams.hstRequestFlag"><th>HST機種<span class="require" name="item_step2" id="hstModel"/></th><td><select id="hstModel" class="2" name="HST機種" validate="required" @change="hstChangeModel" v-model="reqParams.hstModel"><option v-for="model in hstModelList" :value="model.value" :key="model.value">{{ model.label1 }}</option></select></td></tr>
                    <template v-if="reqParams.delivaryTarget== 'hospital'">
                      <tr><th>【機器配送先】</th>
                      <tr>
                        <th>郵便番号<span class="require"/></th>
                        <td>
                          <input
                            id="zip"
                            style="width: 270px; height: 27px;"
                            v-model="reqParams.zip"
                            class="2"
                            :class="{'border-red': invalidShippingPostcode}"
                            name="機器配送先の郵便番号"
                            validate="required|numeric|zip"
                            maxlength="7"
                            :placeholder="postcodePlaceholder"
                            @blur="onZipBlur(reqParams.zip, 'digitErrorPostcode')"
                          />
                          <b-button
                            style="margin-left: 10px; width: 150px; height: 27px;"
                            v-on:click="addressSearch('device',reqParams.zip)">自動入力
                          </b-button>
                          <div v-show="invalidShippingPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                          <div v-show="digitErrorPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                        </td>
                      </tr>
                      <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td><input type="text" v-model="reqParams.address" class="2" name="機器配送先の住所（都道府県、市町村区）" validate="required" maxlength="280"/></td></tr>
                      <tr><th>住所（それ以降の住所）<span class="require"/></th><td><input type="text" v-model="reqParams.address1" class="2" name="機器配送先の住所（それ以降の住所）" validate="required" maxlength="256" ref="address1"/></td></tr>
                      <tr><th>住所（建物名、部屋番号）</th><td><input type="text" v-model="reqParams.address2" maxlength="256"/></td></tr>
                      <tr><th>宛名<span class="require"/></th><td><input type="text" v-model="reqParams.receiverName" maxlength="100" class="2" name="機器配送先の宛名" validate="required"/></td></tr>
                      <tr>
                        <th>連絡先(電話番号)<span class="require"/></th>
                        <td>
                          <input
                            type="text"
                            v-model="reqParams.phoneNumber"
                            maxlength="11"
                            class="2"
                            :class="{'border-red': invalidShippingPhoneNumber}"
                            name="機器配送先の連絡先(電話番号)"
                            validate="required|numeric"
                            :placeholder="phonePlaceholder"
                          />
                          <div v-show="invalidShippingPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                        </td>
                      </tr>
                      <tr><th>配達希望時間帯</th><td><select v-model="reqParams.desiredDeliveryTimeZone" ><option v-for="timeZone in desiredDeliveryTimeZoneList" :value="timeZone.value" :key="timeZone.value">{{ timeZone.label1 }}</option></select></td></tr>
                    </template>
                    <template v-if="isHonsha || isAdmin || isSalesOffice">
                      <tr><th>【結果送付先】</th></tr>
                      <tr>
                        <th>郵便番号<span class="require"/></th>
                        <td>
                          <input
                            id="resultZip"
                            style="width: 270px; height: 27px;"
                            v-model="reqParams.resultZip"
                            maxlength="7"
                            class="2"
                            :class="{'border-red': invalidDeliveryPostcode}"
                            name="結果送付先の郵便番号"
                            validate="required|numeric|zip"
                            :placeholder="postcodePlaceholder"
                            @blur="onZipBlur(reqParams.resultZip, 'digitErrorResultPostcode')"
                          />
                          <b-button
                            style="margin-left: 10px; width: 150px; height: 27px;"
                            v-on:click="addressSearch('result',reqParams.resultZip)">自動入力
                          </b-button>
                          <div v-show="invalidDeliveryPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                          <div v-show="digitErrorResultPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                        </td>
                      </tr>
                      <tr><th>住所<span class="require"/></th><td><input type="text" v-model="reqParams.resultAddress" maxlength="280" class="2" name="結果送付先の住所" validate="required" ref="resultAddress"/></td></tr>
                      <tr><th>住所（建物名、部屋番号）</th><td><input type="text" v-model="reqParams.resultBuildingName" maxlength="256"/></td></tr>
                      <tr><th>医療機関名(会社名)</th><td><input type="text" placeholder="宛名を個人宛にする場合、医療機関名(会社名）はこちらに入力してください。" v-model="reqParams.resultCompanyName" maxlength="256"/></td></tr>
                      <tr><th>診療科(部署名)</th><td><input type="text" placeholder="宛名を個人宛にする場合、診療科(部署名）はこちらに入力してください。" v-model="reqParams.resultDivision" maxlength="100"/></td></tr>
                      <tr><th>宛名<span class="require"/></th><td><input type="text" placeholder="宛名に医療機関(会社名)を入れる場合、「医療機関名(会社名)」「診療科(部署名)」欄は空欄にしてください。" v-model="reqParams.resultReceiverName" maxlength="100" class="2" name="結果送付先の宛名" validate="required"/></td></tr>
                      <tr>
                        <th>連絡先(電話番号)<span class="require"/></th>
                        <td>
                          <input
                            type="text"
                            v-model="reqParams.resultPhoneNumber"
                            maxlength="11"
                            class="2"
                            :class="{'border-red': invalidDeliveryPhoneNumber}"
                            name="結果送付先の連絡先(電話番号)"
                            validate="required|numeric"
                            :placeholder="phonePlaceholder"
                          />
                          <div v-show="invalidDeliveryPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                        </td>
                      </tr>
                    </template>
                    <tr><th class="deliverySlip_label">納品書</th>
                      <td>
                        <div>
                          <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="reqParams.deliverySlip" :native-value="true" disabled>必要</b-radio>
                          <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="reqParams.deliverySlip" :native-value="false" disabled>不要</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr><th>デモ</th><td><b-checkbox v-model="reqParams.demo" class="cstmCheckBox" @input="setInspectionPeriodList">デモ(トライアル)</b-checkbox></td></tr>
                    <template v-if="isDealer">
                      <tr/>
                      <tr>
                        <th/><td><b-checkbox class="cstmCheckBox" v-model="isHospitalAgree">申請者がホルター心電図配送ｻｰﾋﾞｽの申込みを行うことについて、該当医療機関の同意を取得しています。</b-checkbox></td>
                      </tr>
                    </template>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="3" label="患者情報" icon="account">
              <div id="item-contens" v-bind:key="renderKey">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left"  @click.prevent="Backward">前へ</b-button>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                  <span>患者の情報を入力してください。</span>
                </div>
                <template v-for="(patient, index) in reqParams.patientsData">
                  <div class="card-content margin-top" :key="index">
                    <table>
                      <tr v-if="index > 0">
                        <td colspan="2">
                          <b-button style="float:right; width:27px; height:27px; border:none;" icon-left="close-box-outline" @click="deletePatient(index)"></b-button>
                        </td>
                      </tr>
                      <tr><th>診察券ID（患者ID）<span class="require" /></th><td><input type="text" v-model="patient.patientId" @input="patient.patientId = $event.target.value.replace(/^\s+/, '')" maxlength="50" class="3" :name="index+1+'番目、診察券ID（患者ID）'" validate="required" /></td></tr>
                      <tr><th>患者名<span class="require" /></th><td><input type="text" style="margin-right: 5px; width: 446px !important;" placeholder="姓" v-model="patient.patientFamilyName" class="3" :name="index+1+'番目、患者名(姓)'" validate="required" maxlength="49"/><input type="text" style="width: 446px !important;height:27px !important;" placeholder="名" v-model="patient.patientFirstName" class="3" :name="index+1+'番目、患者名(名)'" validate="required" maxlength="49" @blur="focusLostPatientFirstName(index)"/></td></tr>
                      <tr><th>患者名（カナ）<span class="require" /></th><td><input type="text" style="margin-right: 5px; width: 446px !important;" placeholder="セイ" v-model="patient.patientFamilyNameKana" class="3" :name="index+1+'番目、患者名カナ(セイ)'" validate="required|kana" maxlength="49"/><input type="text" style="width: 446px !important;height:27px !important;" placeholder="メイ" v-model="patient.patientFirstNameKana" class="3" :name="index+1+'番目、患者名カナ(メイ)'" validate="required|kana" maxlength="49"/></td></tr>
                      <tr><th>性別<span class="require" /></th><td>
                        <div class="block 3" validate="radioRequire" :name="index+1+'番目、性別'" >
                          <b-radio size="is-small" v-model="patient.gender" native-value="-">-</b-radio>
                          <b-radio size="is-small" v-model="patient.gender" native-value="男">男</b-radio>
                          <b-radio size="is-small" v-model="patient.gender" native-value="女">女</b-radio>
                        </div></td>
                      </tr>
                      <tr><th>生年月日<span class="require"/></th><td><input type="date" v-model="patient.birthday" :input="inputBirthday(patient.birthday,index)" class="3" :name="index+1+'番目、患者の生年月日'" validate="required|date|birthDay" :max="yyyy_hyp_MM_hyp_dd(new Date())" style="width:150px;height:27px;"/><span v-if="patient.birthday" style="margin-left:10px;">{{patient.japaneseCalendar}}</span></td></tr>
                      <tr><th>年齢</th><td><input type="text" disabled v-model="patient.age"/></td></tr>
                      <tr><th>検査目的<span class="require"/></th>
                        <td>
                          <select v-model="patient.inspectionPurpose" class="3" :name="index+1+'番目、患者の検査目的'" validate="required">
                            <option v-for="inspectionPurpose in inspectionPurposeList" :value="inspectionPurpose.value" :key="inspectionPurpose.value">{{ inspectionPurpose.label1 }}</option>
                          </select>
                        </td>
                      </tr>
                      <tr><th>ペースメーカー<span class="require"/></th>
                        <td>
                          <select v-model="patient.pacemaker" class="3" :name="index+1+'番目、患者のペースメーカー'" validate="required">
                            <option></option>
                            <option value="1">有り</option>
                            <option value="2">無し</option>
                          </select>
                        </td>
                      </tr>
                      <tr><th>基礎疾患・合併症<span class="require" v-if='reqParams.judgmentFlag'/></th><td><input type="text" v-model="patient.underlyingDisease" class="3" maxlength="256" :name="index+1+'番目、基礎疾患・合併症'" :validate="`${reqParams.judgmentFlag ? 'required' : ''}`"/></td></tr>
                      <tr><th>投薬状況<span class="require" v-if='reqParams.judgmentFlag'/></th><td><input type="text" v-model="patient.dosingStatus" maxlength="256" class="3" :name="index+1+'番目、投薬状況'" :validate="`${reqParams.judgmentFlag ? 'required' : ''}`"/></td></tr>
                      <tr><th>主訴<span class="require" v-if='reqParams.judgmentFlag'/></th><td><input type="text" v-model="patient.chiefComplaint" maxlength="256" class="3" :name="index+1+'番目、主訴'" :validate="`${reqParams.judgmentFlag ? 'required' : ''}`"/></td></tr>
                      <tr><th>次回受診日</th><td><input type="date" v-model="patient.nextDate" class="3" :name="index+1+'番目、患者の次回受診日'" validate="date|notPastDay" style="width:150px;height:27px;" :min="yyyy_hyp_MM_hyp_dd(new Date())"/></td></tr>
                      <tr><th></th><td><span style="font-size:12px;">次回受診日までの結果返却を保証するものではありません</span></td></tr>
                      <template v-if="reqParams.delivaryTarget== 'home'">
                        <tr>
                          <th>郵便番号<span class="require"/></th>
                          <td>
                            <input
                              :id="`zip_${index}`"
                              v-model="patient.zip"
                              type="text"
                              maxlength="7"
                              style="width: 270px; height: 27px;"
                              class="3"
                              :class="{'border-red': patient.invalidPatientPostcode}"
                              :name="index+1+'番目、患者の郵便番号'"
                              validate="required|numeric|zip"
                              :placeholder="postcodePlaceholder"
                              @blur="onZipBlur(patient.zip, patient)"
                            />
                            <b-button
                              style="margin-left: 10px; width: 150px; height: 27px;"
                              v-on:click="patientAddressSearch(index,patient.zip)">自動入力
                            </b-button>
                            <div v-show="patient.invalidPatientPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                            <div v-show="patient.digitErrorPatientPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                          </td>
                        </tr>
                        <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td><input type="text" v-model="patient.address" maxlength="256" class="3" :name="index+1+'番目、患者の住所（都道府県、市町村区）'" validate="required"/></td></tr>
                        <tr><th>住所（それ以降の住所）<span class="require"/></th><td><input type="text"  :id="`address1_${index}`" v-model="patient.address1" maxlength="256" class="3" :name="index+1+'番目、患者の住所（それ以降の住所）'" validate="required"/></td></tr>
                        <tr><th>住所（建物名、部屋番号）</th><td><input type="text" v-model="patient.address2" maxlength="256"/></td></tr>
                        <tr><th>宛名<span class="require"/></th><td><input type="text" v-model="patient.receiverName" maxlength="100" class="3" :name="index+1+'番目、患者の宛名'" validate="required"/></td></tr>
                        <tr>
                          <th>連絡先（自宅または携帯）<span class="require" /></th>
                          <td>
                            <input
                              type="text"
                              v-model="patient.phoneNumber"
                              maxlength="11"
                              :placeholder="phonePlaceholder"
                              class="3"
                              :class="{'border-red': patient.invalidPatientPhoneNumber}"
                              :name="index+1+'番目、患者の連絡先（自宅または携帯）'"
                              validate="required|numeric"
                            />
                            <div v-show="patient.invalidPatientPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                          </td>
                        </tr>
                        <tr><th></th><td><span style="font-size:12px;">携帯電話（スマートフォン）をお持ちの場合は、携帯電話（スマートフォン）の番号をご入力ください。検査受付完了時および機器が未返却の場合に、<br>ショートメッセージが自動送信されます。</span></td></tr>
                        <tr><th>配達希望時間帯</th><td><select v-model="patient.desiredDeliveryTimeZone" ><option v-for="timeZone in desiredDeliveryTimeZoneList" :value="timeZone.value" :key="timeZone.value">{{ timeZone.label1 }}</option></select></td></tr>
                      </template>
                      <tr><th>備考、その他、注意事項</th><td><textarea v-model="patient.memo" maxlength="256" style="resize:vertical;max-width:100%;"></textarea></td>
                      </tr>
                    </table>
                  </div>
                </template>
                <div class="card-content margin-top">
                    <table>
                      <tr>
                        <th style="vertical-align:top;">注意事項</th>
                        <td>出荷日は「配送情報」で設定します。なお患者情報を複数人設定した場合でも出荷日は同一日となります。</td>
                      </tr>
                    </table>
                </div>
                <div class="margin-top">
                  <b-button style="width:100%;background:#6191eb; color:black;" @click="addPatient" >患者を追加する</b-button>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="4" label="配送情報" icon="truck">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>配送の情報を入力してください。</span>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <!-- 機種名 -->
                    <tr v-if="reqParams.hstRequestFlag"><th colspan="2">【{{reqParams.model | getNameFilter(modelList)}}】と【簡易検査】ウォッチパット 300</th></tr>
                    <tr v-if="!reqParams.hstRequestFlag"><th colspan="2">【{{reqParams.model | getNameFilter(modelList)}}】</th></tr>
                    <tr><th>出荷日<span class="require"/></th>
                      <td>
                        <input type="date" v-model="reqParams.shippingDate"  class="shippingDate 4"  name="出荷日" validate="required|date" disabled style="width:150px;height:27px;"/><a @click="officeCalenderActive = true"><b-icon icon="calendar-cursor"></b-icon></a>
                      </td>
                    </tr>
                    <tr><th>返却日</th><td>{{reqParams.returnDate}}</td></tr>
                    <tr>
                      <th>備考、その他、注意事項</th>
                      <td>
                        <textarea v-model="reqParams.memo" maxlength="256" style="resize:vertical;max-width:100%;"></textarea>
                        <br/><span style="font-size: 14px;">※大変申し訳ございませんが、着日指定のコメントを記載いただいても、対応できかねますので、予めご了承ください。</span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="5" label="申込み" icon="cloud-upload">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward" >前へ</b-button>
                  <span>以下の申込み内容を確認のうえ、下部の「申込みを完了する」ボタンを押下してください。</span>
                </div>
                <!--　申込み詳細 -->
                <holterRequestDetail v-if="!reqParams.demo" v-bind:data="reqParams" v-bind:key="renderKey" :isHideAnalysisOptions="true"/>
                <holterRequestDetail v-if="reqParams.demo" v-bind:data="modifiedReqParams" v-bind:key="renderKey" :isHideAnalysisOptions="true"/>
                <b-button class="is-primary" style="margin-top:5px;width:250px;" @click="requestHolter">申込みを完了する</b-button>
              </div>
            </b-step-item>
            <b-step-item step="6" label="完了" icon="check" :type="{'is-success': true}">
              <section class="unPrintTarget">
                <div class="request-title"><span>ホルター心電図配送ｻｰﾋﾞｽの申込みを受け付けました。</span></div>
                <div class="request-title" v-if="needAgree"><span style="color:red;">翌営業日までに登録済みメールアドレスへ申し込み完了メールが送信されます。</span></div>
                <div class="margin-top">
                  <b-button class="backbutton is-primary" @click="back">戻る</b-button>
                  <b-button class="printbutton is-primary" icon-left="printer" @click="print">印刷</b-button>
                </div>
              </section>
              <section class="printTarget">
                <div id="item-contens">
                  <div class="card-content margin-top printMargin">
                    <table v-if="reqParams.hstRequestFlag">
                      <tr><th colspan="2">【{{reqParams.model | getNameFilter(modelList)}}】</th></tr>
                      <tr><th>受付日時</th><td>{{requestDate}}</td></tr>
                      <tr><th>受付番号</th><td>{{receiptNumber}}</td></tr>
                      <tr><th colspan="2">【簡易検査】ウォッチパット 300</th></tr>
                      <tr><th>受付日時</th><td>{{hstRequestDate}}</td></tr>
                      <tr><th>受付番号</th><td>{{hstReceptionNumber}}</td></tr>
                    </table>
                    <table v-if="!reqParams.hstRequestFlag">
                      <tr><th colspan="2">【{{reqParams.model | getNameFilter(modelList)}}】</th></tr>
                      <tr><th>受付日時</th><td>{{requestDate}}</td></tr>
                      <tr><th>受付番号</th><td>{{receiptNumber}}</td></tr>
                    </table>
                  </div>
                </div> 
                <holterRequestDetail v-if="!reqParams.demo" v-bind:data="reqParams" v-bind:key="renderKey" :isHideAnalysisOptions="true"/>
                <holterRequestDetail v-if="reqParams.demo" v-bind:data="modifiedReqParams" v-bind:key="renderKey" :isHideAnalysisOptions="true"/>
              </section>
            </b-step-item>
          </b-steps>
        </div>
        </form>
      </div>
    </section>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal v-if="isSalesOffice || isHonsha || isAdmin" :selectRole="[role.role_hospital]" :selectStatus="extUserStatus.registed" :serviceId="serviceId" title="医療機関選択" labelForOrg="医療機関名" @select="setOrganization"></organizationSelectModal>
      <facilitySelectModal v-if="isDealer" :dealerId="userId" @select="setfacility"></facilitySelectModal>
    </b-modal>
    <b-modal :active.sync="officeCalenderActive" has-modal-card>
      <officeCalenderModal :miniday="miniday" :maxDay="maxday" :disabledDays="disabledDays" @select="setShippingDate" @change-page="holterChangePage"></officeCalenderModal>
    </b-modal>
  </div>
</template>
<script>
import {
  role,
  atLaunchHidden,
  consentStatement,
  choicesType,
  extUserStatus,
  LendingPeriod,
  analysisOption,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  digitErrorZipMessage,
} from "@/components/mock/base/const.js";
import holterRequest from "@/components/mock/common/HolterRequestDetail";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import FacilitySelectModal from "@/components/mock/philips/common/FacilitySelectModal";
import OfficeCalenderModal from "@/components/mock/guest/OfficeCalenderModal";
import {service} from "@/components/mock/base/const.js";
const HOLIDAY_JP = require("@holiday-jp/holiday_jp");
const PH_HOLIDAYS = require('@/components/mock/base/philipsHollday.json');

const InitialPatientValue = {
  patientId: "",
  patientFamilyName: "",
  patientFirstName: "",
  patientFamilyNameKana: "",
  patientFirstNameKana: "",
  gender: "",
  birthday: "",
  age: "",
  japaneseCalendar: "",
  pacemaker: "",
  inspectionPurpose: "",
  underlyingDisease: "",
  dosingStatus: "",
  chiefComplaint: "",
  zip: "",
  address: "",
  address1: "",
  address2: "",
  phoneNumber: "",
  receiverName: "",
  memo: "",
  // 半角数字エラーメッセージ表示
  invalidPatientPostcode: false,
  invalidPatientPhoneNumber: false,
  digitErrorPatientPostcode: false,
};

export default {
  name: "HolterRequest",
  methods: {
    Backward: function() {
      this.activeStep -= 1;
    },
    Forward: function(event) {
      // バリデーションチェック
      let stepItems = document.getElementsByClassName("step-item")
      let target
      for(let item of stepItems){
        if(item.getAttribute("style") != "display: none;"){
          target = item
        }
      }
      let activeStep = target ? target.getAttribute("step") : ""
      if(activeStep){
        let elements = document.getElementsByClassName(activeStep)
        let result = this.selfMadeValidation(elements)
        if(result.isError){
          this.showErrorMessage(result.msg)
        }else{
          // 再レンダリングの為、フラグ切替
          this.renderKey = !this.renderKey
          this.activeStep += 1;
        }
      }
    },
    requestHolter: function() {
      let model = this.modelList.find(val => val.value == this.reqParams.model)
      let hstModel = this.hstModelList.find(val => val.value == this.reqParams.hstModel)
      let messsage = model.label1
      if (hstModel) {
        messsage += "、" + hstModel.label1
      }
      messsage += "の検査を申込みます。<br/>申込み内容、機種が正しいことを確認して「OK」ボタンを押してください。<br/>お申込み後のキャンセルは申請一覧より該当受付番号右端のメールボタンからキャンセル依頼をお願いします。"
      this.$dialog.confirm({
        title: "申込み確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = true;
          let excuteApi = this.setHolterApplicationPOST;
          let successCallBack = this.setHolterApplicationPOSTSuccess;
          let errorCallBack = this.setHolterApplicationPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
          if(this.compleateFlg && this.requestDate && this.receiptNumber){
            this.jumpToTop();
            this.activeStep += 1;
          }else {
            this.showErrorMessage("申込みの登録処理に失敗しました。\n再度「完了」のボタンをクリックしてください。\nこのメッセージが繰り返し表示される場合は、Philips営業担当者にご連絡ください。");
          }
        }
      });
    },
    back: function() {
      if (this.preReceiptNumber) {
        this.$router.push({ path: "/guest/holterMenu" });
      } else {
        this.$router.go(-1);
      }
    },
    goHome: function() {
      if (this.userInfo.belongsId) {
        this.$router.push({ path: "/guest/holterMenu" });
      } else {
        this.back();
      }
    },
    addPatient: function() {
      this.reqParams.patientsData.push({ ...InitialPatientValue });
      this.reqParams.shippingDate = "";
      this.reqParams.returnDate = "";
      this.reqParams.hstShippingDate = "";
      this.reqParams.hstReturnDate = "";
      // QA476 追加患者の郵便番号検索
      const index = this.reqParams.patientsData.length - 1;
      const item = this.reqParams.patientsData[index];
      this.$watch(() => item.zip,
        async (newZip) => {
          if (!newZip || newZip.length !== 7) return;
          if (isNaN(Number(newZip))) return;
          await this.patientAddressSearch(index, newZip);
          // 検索後に住所欄へフォーカス
          this.$nextTick(() => {
            var address1 = document.getElementById(`address1_${index}`);
            address1.focus();
          });
        }
      );
    },
    deletePatient: function(index) {
      this.reqParams.patientsData.splice(index, 1);

      this.reqParams.shippingDate = ""
      this.reqParams.returnDate = ""
      this.reqParams.hstShippingDate = ""
      this.reqParams.hstReturnDate = ""
    },
    hstChangeModel: async function() {
      let _this = this
      _this.reqParams.hstShippingDate = ""
      _this.reqParams.hstReturnDate = ""
      
      //最短出荷日の変更
      let hstModel = this.hstModelList.find(val => val.value == this.reqParams.hstModel)
      if(hstModel && hstModel.label1 && hstModel.label1.match(/スリーププロファイラー/)){
        //●SP　　：翌々営業日後まで選択できない（申込時点から3営業日目は選択可能）
        await _this.getBusinessDayPOST(null, 3, function(result) {
          _this.miniday = new Date(result.obj.date)
        })
      } else {
        //●SP以外：翌営業日まで：翌営業日まで選択できない　　（申込時点から2営業日目は選択可能）
        await this.getBusinessDayPOST(null, 2, function(result) {
          _this.miniday = new Date(result.obj.date)
        })
      }
      // 基本情報ステップの最短出荷日を表示
      if(this.reqParams.model && this.reqParams.hstModel) {
        this.hstEarliestShippingDate = await this.calculateEarliestShippingDate(true);
      } else {
        this.hstEarliestShippingDate = "";
      }

      // 最短出荷日が大きいほう使用する処理
      if (_this.reqParams.hstRequestFlag){
        if(this.holterEarliestShippingDate == ""){
          this.earliestShippingDate = "";
        }else if(this.hstEarliestShippingDate != "" && this.holterEarliestShippingDate != ""){
          if (this.hstEarliestShippingDate > this.holterEarliestShippingDate){
            this.earliestShippingDate = this.hstEarliestShippingDate;
          }else{
            this.earliestShippingDate = this.holterEarliestShippingDate;
          }
        }else if(this.hstEarliestShippingDate != "" && this.holterEarliestShippingDate == ""){
            this.earliestShippingDate = this.hstEarliestShippingDate;
        }else if(this.hstEarliestShippingDate == "" && this.holterEarliestShippingDate != ""){
            this.earliestShippingDate = this.holterEarliestShippingDate;
        }else{
            this.earliestShippingDate = "";
        }
      }else{
        this.earliestShippingDate = this.holterEarliestShippingDate;
      }
    },
    changeModel: async function() {
      let _this = this
      _this.reqParams.shippingDate = ""
      _this.reqParams.returnDate = ""

      //最短出荷日の変更
      //●ePatch：翌営業日まで選択できない　　（申込時点から2営業日目は選択可能）
      await this.getBusinessDayPOST(null, 2, function(result) {
        _this.miniday = new Date(result.obj.date)
      })

      // 基本情報ステップの最短出荷日を表示
      if(this.reqParams.model) {
        this.holterEarliestShippingDate = await this.calculateEarliestShippingDate(false);
      } else {
        this.holterEarliestShippingDate = "";
      }

      // 最短出荷日が大きいほう使用する処理
      if (_this.reqParams.hstRequestFlag){
        if(this.holterEarliestShippingDate == ""){
            this.earliestShippingDate = "";
        }else if(this.hstEarliestShippingDate != "" && this.holterEarliestShippingDate != ""){
          if (this.hstEarliestShippingDate > this.holterEarliestShippingDate){
            this.earliestShippingDate = this.hstEarliestShippingDate;
          }else{
            this.earliestShippingDate = this.holterEarliestShippingDate;
          }
        }else if(this.hstEarliestShippingDate != "" && this.holterEarliestShippingDate == ""){
            this.earliestShippingDate = this.hstEarliestShippingDate;
        }else if(this.hstEarliestShippingDate == "" && this.holterEarliestShippingDate != ""){
            this.earliestShippingDate = this.holterEarliestShippingDate;
        }else{
            this.earliestShippingDate = "";
        }
      }else{
        this.earliestShippingDate = this.holterEarliestShippingDate;
      }
    },
    async calculateEarliestShippingDate(isContainHst) {
      let fromDate = new Date(this.miniday.getFullYear(), this.miniday.getMonth(), 1);
      let stockCalendar = [];
      let earliestDate = null;
      let earliestDateString = "";

      let THIS = this;
      let addMonthCount = 0;
      this.$root.$children[0].loadingStart();
      while(true) {
        let requestDate = new Date(fromDate.setMonth(fromDate.getMonth() + addMonthCount));
        let body = {
          startDate: this.yyyy_sla_MM_sla_dd(requestDate),
          modelId: this.reqParams.model
        };

        await this.apiCall(
          function (client){
            if (isContainHst) {
              return client.apis.internalShipmentCalendar.getStockEPWPCalendarPOST({
                body: body
              });
            } else {
              return client.apis.internalShipmentCalendar.getStockCalendarPOST({
                body: body
              });
            }
          },
          function(result){
            stockCalendar = result.obj;
            for(var i = 0; i < stockCalendar.length; i++) {
              let day = stockCalendar[i];
              let formattedDate = fromDate.getFullYear() + "/" + day.date.replace("-", "/");
              if(THIS.isDisabledDay(new Date(formattedDate), fromDate, new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 0))) {
                continue;
              }
              if(THIS.reqParams.patientsData.length <= day.stock) {
                earliestDate = new Date(formattedDate);
                break;
              }
            }
          },
          function(result){
            THIS.showErrorMessage(result);
          }
        );

        if(earliestDate || stockCalendar.length == 0) {
          break;
        } else {
          fromDate.setMonth(fromDate.getMonth() - addMonthCount);
          addMonthCount++;
        }
      }
      this.$root.$children[0].loadingEnd();

      if(earliestDate) {
        earliestDateString = this.yyyy_sla_MM_sla_dd(earliestDate);
      } else {
        earliestDateString = "出荷可能な日程がありません";
      }
      return earliestDateString;
    },
    isDisabledDay(date, fromDate, toDate) {
      if(date < this.miniday || date > this.maxDay) {
        return true;
      }
      if (date.getDay() == 0 || date.getDay() == 6) {
        return true;
      }

      let formattedDay = this.yyyy_hyp_MM_hyp_dd(date);
      let holidays = HOLIDAY_JP.between(fromDate, toDate);
      for(var d of holidays) {
        if (formattedDay == this.yyyy_hyp_MM_hyp_dd(d.date)) {
          return true;
        }
      }

      if(PH_HOLIDAYS.everyyear.includes(this.MM_hyp_dd(date))|| PH_HOLIDAYS.irregular.includes(formattedDay)) {
        return true;
      }

      return false;
    },
    changedAnalysisOption: async function() {
      this.reqParams.judgmentFlag = this.reqParams.analysisOption == this.analysisOption.includedAll
    },
    setShippingDate: function(selectDate){
      this.reqParams.shippingDate = selectDate
      this.reqParams.hstShippingDate = selectDate
      this.shippingDateInput();
      this.hstShippingDateInput();
      this.officeCalenderActive = false;
    },
    holterChangePage: function(sDate, eDate) {
      this.changePage(sDate, eDate, this.reqParams.model)
    },
    changePage: function(sDate, eDate, modelId) {
      let _this = this;
      this.apiCall(
        function(client){
          if (_this.reqParams.hstRequestFlag){
            return client.apis.internalShipmentCalendar.getStockEPWPCalendarPOST({
              body: {
                startDate: sDate,
                modelId: modelId
              }
            });
          }else{
            return client.apis.internalShipmentCalendar.getStockCalendarPOST({
              body: {
                startDate: sDate,
                modelId: modelId
              }
            });
          }
        },
        function(result){
          let disabled = result.obj.filter(data => {
            return data.stock < _this.reqParams.patientsData.length
          })
          _this.disabledDays = disabled
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    shippingDateInput: function() {
      var lendingPeriod = LendingPeriod.holter_fourteen_period;
      var choicesInspectionPeriod = "";
      this.inspectionPeriodList.forEach(ele => {
        if (ele.value == this.reqParams.inspectionPeriod){
          choicesInspectionPeriod = ele.label1
        }
      });
      if (choicesInspectionPeriod && choicesInspectionPeriod.match(/14日/)){
        lendingPeriod = LendingPeriod.holter_fourteen_period;
      } else if (choicesInspectionPeriod && choicesInspectionPeriod.match(/10日/)){
        lendingPeriod = LendingPeriod.holter_tenday_period;
      } else if (choicesInspectionPeriod && choicesInspectionPeriod.match(/7日/)){
        lendingPeriod = LendingPeriod.holter_sevenday_period;
      } else if (choicesInspectionPeriod && choicesInspectionPeriod.match(/5日/)){
        lendingPeriod = LendingPeriod.holter_fiveday_period;
      } else if (choicesInspectionPeriod && choicesInspectionPeriod.match(/24時間/)){
        lendingPeriod = LendingPeriod.holter_oneday_period;
      }
      // 返却日 = 出荷日+3週間(21日)
      let workDate = new Date(this.reqParams.shippingDate);
      workDate = this.getBusinessDay(workDate, lendingPeriod);
      this.reqParams.returnDate = this.yyyy_sla_MM_sla_dd(workDate);
      this.reqParams.hstReturnDate = this.yyyy_sla_MM_sla_dd(workDate);
    },
    hstShippingDateInput: function() {
      var lendingPeriod = LendingPeriod.holter_fourteen_period;
      // 返却日 = 出荷日+3週間(21日)
      let workDate = new Date(this.reqParams.hstShippingDate);
      workDate = this.getBusinessDay(workDate, lendingPeriod);
      this.reqParams.hstReturnDate = this.yyyy_sla_MM_sla_dd(workDate);
    },
    setOrganization: function(organizationInfo){
      this.isInitialZip = true;
      this.isInitialResultZip = true;
      this.reqParams.belongsId = organizationInfo.id + "";
      this.reqParams.hospitalName = organizationInfo.orgName;

      this.reqParams.receiverName = organizationInfo.orgName;
      this.reqParams.resultReceiverName = organizationInfo.orgName;

      this.reqParams.zip = organizationInfo.zip;
      this.reqParams.address = organizationInfo.prefecture + organizationInfo.city;
      this.reqParams.address1 = organizationInfo.address;
      this.reqParams.address2 = organizationInfo.building ? organizationInfo.building : "";
      this.reqParams.phoneNumber = organizationInfo.phoneNumber;

      this.reqParams.resultZip = organizationInfo.zip;
      this.reqParams.resultAddress = organizationInfo.prefecture + organizationInfo.city + organizationInfo.address;
      this.reqParams.resultBuildingName = organizationInfo.building ? organizationInfo.building : "";
      this.reqParams.resultPhoneNumber = organizationInfo.phoneNumber;
      this.reqParams.note = organizationInfo.note;
      this.reqParams.holterJudgmentFlg = organizationInfo.holterJudgmentFlg;
      
      if (!this.belongsId || this.belongsId != organizationInfo.id) {
        // 代理申込時
        this.belongsId = organizationInfo.id
      }
      // 見積りコードが紐づいた検査期間を取得・設定
      this.getChoicesListLinkedEstimate()

      // 前回申込み情報の取得
      this.prevHstSearchParam.belongsId = this.belongsId
      this.getPreviousApplication()
    },
    setfacility:  function(facility){
      this.isInitialZip = true;
      this.isInitialResultZip = true;
      this.reqParams.institutionId = facility.id + "";
      this.reqParams.hospitalName = facility.orgName;

      this.reqParams.receiverName = facility.orgName;
      this.reqParams.resultReceiverName = facility.orgName;

      this.reqParams.zip = facility.postcode;
      this.reqParams.address = facility.prefecture + facility.address;
      this.reqParams.address1 = facility.houseNumber;
      this.reqParams.address2 = facility.building ? facility.building : "";
      this.reqParams.holterJudgmentFlg = facility.holterJudgmentFlg;

      // 見積りコードが紐づいた検査期間を取得・設定
      this.getChoicesListLinkedEstimate()

      // 前回申込み情報の取得
      this.prevHstSearchParam.institutionId = facility.id
      this.getPreviousApplication()
    },
    getChoicesListLinkedEstimate: function() {
      var excuteApi = this.getChoicesListLinkedEstimatePOST;
      var successCallBack = this.getChoicesListLinkedEstimatePOSTSuccess;
      var errorCallBack = this.getChoicesListLinkedEstimatePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getChoicesListLinkedEstimatePOST: function(client){
      let belongId = this.reqParams.belongsId? this.reqParams.belongsId: this.belongsId
      let institutionId = this.reqParams.institutionId? this.reqParams.institutionId: 0

      return client.apis.apiCommon.getChoicesListLinkedEstimatePOST({
        body: {
          belongId: belongId,
          institutionId: institutionId
        }
      });
    },
    getChoicesListLinkedEstimatePOSTSuccess: function(result) {
      //検査期間リストをAPIからの取得値から抽出
      if(this.reqParams.holterJudgmentFlg) {
        this.inspectionPeriodListLinkedEstimate = result.obj.filter(data => { return data.choicesType == this.choicesType.holterInspectionPeriodJudgment});
      }else{
        this.inspectionPeriodListLinkedEstimate = result.obj.filter(data => { return data.choicesType == this.choicesType.holterInspectionPeriod });
      }
      this.inspectionPeriodListLinkedEstimate.unshift({})
    
      let normalWP300 = false
      let specialWP300 = false

      // 併用申し込み用の機種取得
      let allHolterHstKindList = this.getChoiceList(this.choicesType.holterHstKind, false);
      this.hstModelListLinkedEstimate = allHolterHstKindList
      for(let i = 0; i < this.hstModelListLinkedEstimate.length; i++){
        if(this.hstModelListLinkedEstimate[i].value == '7-holt'){
          this.hstModelListLinkedEstimate[i].label1 = "【簡易検査】ウォッチパット300（いびきセンサーなし）"
          break
        }
      }
      // 見積りコードが登録されているHST機種を抽出
      let estimateHstModelList = result.obj.filter(data => { return data.choicesType == this.choicesType.hstKind })
      // 見積りコードが登録されている併用申し込み用の機種を抽出
      let estimateHolterHstKindList = result.obj.filter(data => { return data.choicesType == this.choicesType.holterHstKind});
      
      // 睡眠検査併用申し込みのHST機種の候補を抽出
      for(let i = 0; i < allHolterHstKindList.length; i++){
        // 判定用フラグ初期化
        normalWP300 = false
        specialWP300 = false
        //通常料金に見積りコードが登録されているかAPIからの取得値から判定
        for(let j = 0; j < estimateHstModelList.length; j++){
          if(allHolterHstKindList[i].value.split('-')[0] == estimateHstModelList[j].value){
            let estimateWP300Sensor = result.obj.filter(data => { return data.choicesType == this.choicesType.WP300SnoreSensor })
            let estimateNoSensor = estimateWP300Sensor.filter(data => { return data.value == 1 });
            if (estimateNoSensor.length > 0 ) {
              normalWP300 = true
            }
            break
          }
        }
        //併用申込時の割引料金に見積りコードが登録されているかAPIからの取得値から判定
        for(let j=0; j<estimateHolterHstKindList.length; j++){
          if(allHolterHstKindList[i].value == estimateHolterHstKindList[j].value){
            let estimateWP300Sensor = result.obj.filter(data => { return data.choicesType == this.choicesType.WP300SnoreSensorHolter })
            let estimateNoSensor = estimateWP300Sensor.filter(data => { return data.value == 1 });
            if (estimateNoSensor.length > 0 ) {
              specialWP300 = true
            }
            break
          }
        }

        // 通常料金と割引料金両方の見積りコードが登録されていない場合、リストから削除
        if(!normalWP300 && !specialWP300) {
          for(let j = 0; j < this.hstModelListLinkedEstimate.length; j++){
            if(this.hstModelListLinkedEstimate[j].id == allHolterHstKindList[i].id){
              this.hstModelListLinkedEstimate = this.hstModelListLinkedEstimate.splice(j, j)
              break
            }
          }
        }
      }
      this.hstModelListLinkedEstimate.unshift({})
      
      this.setInspectionPeriodList(this.reqParams.demo)
    },
    getChoicesListLinkedEstimatePOSTError: function(result){
      this.showErrorMessage(result);
    },
    setInspectionPeriodList: function(isDemo){
      if(this.reqParams.hospitalName){
        if(isDemo){
          // 選択肢マスタの検査期間を設定
          this.inspectionPeriodList = this.getChoiceList(this.choicesType.holterInspectionPeriod, false).concat(this.getChoiceList(this.choicesType.holterInspectionPeriodJudgment, false));
          this.inspectionPeriodList.unshift({})
          // 選択肢マスタの併用申し込みの機種を設定
          this.hstModelList = this.getChoiceList(this.choicesType.holterHstKind, false);
          for(let i = 0; i < this.hstModelList.length; i++){
            if(this.hstModelList[i].value == '7-holt'){
              this.hstModelList[i].label1 = "【簡易検査】ウォッチパット300（いびきセンサーなし）"
              break
            }
          }
          this.hstModelList.unshift({})
        } else {
          // 見積りコードが紐づいている検査期間を設定
          this.inspectionPeriodList = this.inspectionPeriodListLinkedEstimate
          // 見積りコードが紐づいている併用申し込みの機種を設定
          this.hstModelList = this.hstModelListLinkedEstimate
          if(this.hstModelList.length <= 1){
            //併用申し込みの設定を初期化
            this.reqParams.hstRequestFlag = false
            this.reqParams.hstModel = ""
          }
        }
        this.changeModel()
      }
    },
    print: function(){
      window.print();
    },
    inputBirthday: function(birthday,index){
      let age = this.getAge(birthday)
      if(!isNaN(Number(age))){
        this.reqParams.patientsData[index].age = age < 0 ? 0 : age

        const date = new Date(birthday);
        const options = {era: 'long'};
        this.reqParams.patientsData[index].japaneseCalendar = "【"+this.getJapaneseCalendar(date)+"】"
      }else{
        this.reqParams.patientsData[index].age = ""
      }
    },
    setHolterApplicationPOST: function(client) {
      if(this.reqParams.delivaryTarget == 'home'){
        this.reqParams.leadWireAdapter = false;
      }
      let obj = JSON.parse(JSON.stringify(this.reqParams));
      
      if(this.reqParams.demo) {
        obj = JSON.parse(JSON.stringify(this.modifiedReqParams));
      }
      obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      obj.hstShippingDate = obj.hstShippingDate ? obj.hstShippingDate.replace(/-/g, "/") : ""
      obj.clientDate = new Date().toString();
      if (!obj.isResultMailSend) {
        obj.hospitalMail = ""
      }
      for(const patient of obj.patientsData){
        patient.patientId = patient.patientId ? patient.patientId.replace(/^\s+/, "") : patient.patientId
        patient.age = patient.age + ""
        patient.birthday = patient.birthday ? patient.birthday.replace(/-/g, "/") :""
        patient.nextDate = patient.nextDate ? patient.nextDate.replace(/-/g, "/") : ""
      }
      obj.belongsId = this.belongsId
      // クイックオーダーのロジックを追加
      if(this.isApplicationValid){
        obj.preReceiptNumber = this.preReceiptNumber;
        obj.preKind = this.preKind
      }
      return client.apis.externalHolter.setHolterApplicationPOST({
        body:obj
      });
    },
    setHolterApplicationPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.requestDate = result.obj.requestDate
      this.receiptNumber = result.obj.receiptNumber
      this.hstRequestDate = result.obj.hstRequestDate
      this.hstReceptionNumber = result.obj.hstReceptionNumber
      this.compleateFlg = true;
    },
    setHolterApplicationPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    addressSearch: function(target,val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return; 
        if(target!="result"){
          this.reqParams.address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.reqParams.address1 = "";
          this.reqParams.address2 = "";

          // QA476 住所設定後フォーカスを移動する
          this.focusMove("address1");
          this.digitErrorPostcode = false;
        }else{
          this.reqParams.resultAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
          this.reqParams.resultBuildingName = "";

          // QA476 住所設定後フォーカスを移動する
          this.focusMove("resultAddress");
          this.digitErrorResultPostcode = false;
        }
      })
    },
    patientAddressSearch: async function(index,val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      await this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return;
        this.reqParams.patientsData[index].address = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        this.reqParams.patientsData[index].address1 = "";
        this.reqParams.patientsData[index].address2 = "";

        // 再レンダリングの為、フラグ切替
        this.renderKey = !this.renderKey
      })
    },
    postCodeSearch: function(){
      let excuteApi = this.getAddressFromPostCodePOST;
      let successCallBack = this.getAddressFromPostCodePOSTSuccess;
      let errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      this.searchTargetPostCode = ""
    },
    getAgreementStr: async function() {
      let excuteApi = this.getConsentStatementPOST;
      let successCallBack = this.getConsentStatementPOSTSuccess;
      let errorCallBack = this.getConsentStatementPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getConsentStatementPOST: function(client) {
      let type = this.consentStatement.holter_hospital;
      if(this.isDealer){
        type = this.consentStatement.holter_dealer;
      }
      return client.apis.apiCommon.getConsentStatementPOST({
        body: {
          type: type
        } 
      });
    },
    getConsentStatementPOSTSuccess: function(result) {
      if(result.body.contents != ""){
        this.agreement = result.body.contents;
        this.canAgree = true;
      } else {
        this.agreement = "利用規約が登録されていません。";
      }
    },
    getConsentStatementPOSTError: function(result) {
      this.agreement == "利用規約を取得できませんでした。";
    },    
    getChoicesList: async function() {
      this.hstModelList = this.getChoiceList(this.choicesType.holterHstKind, false);
      for(let i = 0; i < this.hstModelList.length; i++){
        if(this.hstModelList[i].value == '7-holt'){
          this.hstModelList[i].label1 = "【簡易検査】ウォッチパット300（いびきセンサーなし）"
          break
        }
      }
      this.modelList = this.getChoiceList(this.choicesType.holterKind, false);
      this.desiredDeliveryTimeZoneList = this.getChoiceList(this.choicesType.deliveryTime, false);
      this.inspectionPurposeList = this.getChoiceList(this.choicesType.holterInspectionPurpose, false);
      this.analysisOptionList = this.getChoiceList(this.choicesType.holterAnalysisOp, false);
      this.inspectionPeriodList = this.getChoiceList(this.choicesType.holterInspectionPeriod, false);
      this.hstModelList.unshift({})
      this.modelList.unshift({})
      this.desiredDeliveryTimeZoneList.unshift({})
      this.inspectionPurposeList.unshift({})
      this.analysisOptionList.unshift({})
    },
    getPreviousApplication: async function() {
      let excuteApi = this.getPreviousApplicationDetailsPOST;
      let successCallBack = this.getPreviousApplicationDetailsPOSTSuccess;
      let errorCallBack = this.getPreviousApplicationDetailsPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPreviousApplicationDetailsPOST: function(client) {
      return client.apis.apiCommon.getPreviousApplicationDetailsPOST({
        body: this.prevHstSearchParam
      });
    },
    getPreviousApplicationDetailsPOSTSuccess: function(result) {
      this.reqParams.doctorName = result.body.doctorName
      this.reqParams.analysisOption = result.body.analysisOption
    },
    getPreviousApplicationDetailsPOSTError: function(result) {
      // 取得失敗時
    },
    focusLostPatientFirstName: function(index) {
      if(!this.reqParams.patientsData[index].receiverName || this.reqParams.patientsData[index].receiverName==""){
        this.reqParams.patientsData[index].receiverName = this.reqParams.patientsData[index].patientFamilyName + " " + this.reqParams.patientsData[index].patientFirstName
        // 再レンダリングの為、フラグ切替
        this.renderKey = !this.renderKey
      }
    }, 
    getApplication: async function() {
      if (this.preKind === 'hst') {
        var excuteApi = this.getHstRequestDetailPOST;
        var successCallBack = this.getHstRequestDetailPOSTSuccess;
        var errorCallBack = this.getHstRequestDetailPOSTError;
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else if (this.preKind === 'psg') {
        var excuteApi = this.getAnalysisDetailPOST;
        var successCallBack = this.getAnalysisDetailPOSTSuccess;
        var errorCallBack = this.getAnalysisDetailPOSTError;
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else if (this.preKind === 'holter') {
        var excuteApi = this.getHolterRequestDetailPOST;
        var successCallBack = this.getHolterRequestDetailPOSTSuccess;
        var errorCallBack = this.getHolterRequestDetailPOSTError;
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    getHstRequestDetailPOST: function(client) {
      return client.apis.internalHst.getHstRequestDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getHstRequestDetailPOSTSuccess: function(result) {
      this.isApplicationValid = true
      var obj = result.obj.applicationDetails

      // 施設紹介先からの遷移の場合は、医師名、事務担当者名、患者IDを繋ぎ込まない
      if(this.introduction){
        this.reqParams.doctorName = ""
        this.reqParams.clerkName = ""
        this.reqParams.patientsData[0].patientId = ""
      }else{
        this.reqParams.doctorName = obj.doctorName
        this.reqParams.clerkName = obj.clerkName
        this.reqParams.patientsData[0].patientId = obj.patientsData[0].patientId
      }

      this.reqParams.delivaryTarget = obj.delivaryTarget

      if(this.reqParams.delivaryTarget == "hospital" && !this.introduction){
        this.reqParams.zip = obj.zip 
        this.reqParams.address = obj.address 
        this.reqParams.address1 = obj.address1 
        this.reqParams.address2 = obj.address2 
        this.reqParams.receiverName = obj.receiverName
        this.reqParams.phoneNumber = obj.phoneNumber 
        this.reqParams.desiredDeliveryTimeZone = obj.desiredDeliveryTimeZone
      } else if (this.reqParams.delivaryTarget == "hospital" && this.introduction) {
        this.reqParams.delivaryTarget = "home"
      }
      
      this.reqParams.patientsData[0].patientFamilyName = obj.patientsData[0].patientFamilyName
      this.reqParams.patientsData[0].patientFirstName = obj.patientsData[0].patientFirstName
      this.reqParams.patientsData[0].patientFamilyNameKana = obj.patientsData[0].patientFamilyNameKana
      this.reqParams.patientsData[0].patientFirstNameKana = obj.patientsData[0].patientFirstNameKana
      this.reqParams.patientsData[0].gender = obj.patientsData[0].gender
      this.reqParams.patientsData[0].birthday = obj.patientsData[0].birthday ? obj.patientsData[0].birthday.replace(/\//g, "-") : ""

      this.reqParams.patientsData[0].zip = obj.patientsData[0].zip
      this.reqParams.patientsData[0].address = obj.patientsData[0].address
      this.reqParams.patientsData[0].address1 = obj.patientsData[0].address1
      this.reqParams.patientsData[0].address2 = obj.patientsData[0].address2
      this.reqParams.patientsData[0].receiverName = obj.patientsData[0].receiverName
      this.reqParams.patientsData[0].phoneNumber = obj.patientsData[0].phoneNumber
    },
    getHstRequestDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getAnalysisDetailPOST: function(client) {
      return client.apis.externalAnalysis.getAnalysisDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getAnalysisDetailPOSTSuccess: function(result) {
      this.isApplicationValid = true
      var obj = result.obj.requestDetails

      // 施設紹介先からの遷移の場合は、医師名、事務担当者名、患者IDを繋ぎ込まない
      if(this.introduction){
        this.reqParams.doctorName = ""
        this.reqParams.clerkName = ""
        this.reqParams.patientsData[0].patientId = ""
      }else{
        this.reqParams.doctorName = obj.doctorName
        this.reqParams.clerkName = obj.clerkName
        this.reqParams.patientsData[0].patientId = obj.patientId
      }
      
      this.reqParams.patientsData[0].patientFamilyName = obj.patientFamilyName
      this.reqParams.patientsData[0].patientFirstName = obj.patientFirstName
      this.reqParams.patientsData[0].patientFamilyNameKana = obj.patientFamilyNameKana
      this.reqParams.patientsData[0].patientFirstNameKana = obj.patientFirstNameKana
      this.reqParams.patientsData[0].gender = obj.gender
      this.reqParams.patientsData[0].birthday = obj.birthday ? obj.birthday.replace(/\//g, "-") : ""
    },
    getAnalysisDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getHolterRequestDetailPOST: function(client) {
      return client.apis.internalHolter.getHolterRequestDetailPOST({
        body:{
          receiptNumber:this.preReceiptNumber,
        }
      });
    },
    getHolterRequestDetailPOSTSuccess: function(result) {
      this.isApplicationValid = true
      var obj = result.obj.applicationDetails

      // 施設紹介先からの遷移の場合は、医師名、事務担当者名、患者IDを繋ぎ込まない
      if(this.introduction){
        this.reqParams.doctorName = ""
        this.reqParams.clerkName = ""
        this.reqParams.patientsData[0].patientId = ""
      }else{
        this.reqParams.doctorName = obj.doctorName
        this.reqParams.clerkName = obj.clerkName
        this.reqParams.patientsData[0].patientId = obj.patientsData[0].patientId
      }

      this.reqParams.delivaryTarget = obj.delivaryTarget
      
      if(this.reqParams.delivaryTarget == "hospital" && !this.introduction){
        this.reqParams.zip = obj.zip 
        this.reqParams.address = obj.address 
        this.reqParams.address1 = obj.address1 
        this.reqParams.address2 = obj.address2 
        this.reqParams.receiverName = obj.receiverName
        this.reqParams.phoneNumber = obj.phoneNumber 
        this.reqParams.desiredDeliveryTimeZone = obj.desiredDeliveryTimeZone 
      } else if (this.reqParams.delivaryTarget == "hospital" && this.introduction) {
        this.reqParams.delivaryTarget = "home"
      }

      // 患者情報
      this.reqParams.patientsData[0].patientFamilyName = obj.patientsData[0].patientFamilyName
      this.reqParams.patientsData[0].patientFirstName = obj.patientsData[0].patientFirstName
      this.reqParams.patientsData[0].patientFamilyNameKana = obj.patientsData[0].patientFamilyNameKana
      this.reqParams.patientsData[0].patientFirstNameKana = obj.patientsData[0].patientFirstNameKana
      this.reqParams.patientsData[0].gender = obj.patientsData[0].gender
      this.reqParams.patientsData[0].birthday = obj.patientsData[0].birthday ? obj.patientsData[0].birthday.replace(/\//g, "-") : ""

      //院内貸出の場合、住所を繋ぎ込まない
      if(obj.depositMachineFlag){
        this.reqParams.patientsData[0].zip = ""
        this.reqParams.patientsData[0].address = ""
        this.reqParams.patientsData[0].address1 = ""
        this.reqParams.patientsData[0].address2 = ""
        this.reqParams.patientsData[0].receiverName = ""
      }else{
        this.reqParams.patientsData[0].zip = obj.patientsData[0].zip
        this.reqParams.patientsData[0].address = obj.patientsData[0].address
        this.reqParams.patientsData[0].address1 = obj.patientsData[0].address1
        this.reqParams.patientsData[0].address2 = obj.patientsData[0].address2
        this.reqParams.patientsData[0].receiverName = obj.patientsData[0].receiverName
      }

      this.reqParams.patientsData[0].phoneNumber = obj.patientsData[0].phoneNumber
    },
    getHolterRequestDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    /**
     * QA476 郵便番号からフォーカスが外れたら桁数に応じて桁数判定フラグを設定する
     * @param zipCode 郵便番号
     * @param flagName 桁数判定フラグ
     */
    onZipBlur(zipCode, flagName) {
      if (flagName !== null && typeof flagName === "object" && !Array.isArray(flagName)) {
        flagName.digitErrorPatientPostcode = zipCode.length < 7;
      }else {
        this[flagName] = zipCode.length < 7;
      }
    },
    /**
     * QA476 引数に指定した項目の末尾にフォーカスを移動する
     * @param refName フォーカスをあてる項目定義
     */
    focusMove(refName) {
      this.$nextTick(() => {
        const element = this.$refs[refName];
        if (element) {
          element.focus();
          const length = element.value.length;
          element.setSelectionRange(length, length);
        }
      })
    },
    setupZipWatchers() {
      this.reqParams.patientsData.forEach((item, index) => {
        this.$watch(() => item.zip,
          async (newZip, oldZip) => {
            if (newZip === oldZip) return;
            // 何も入ってないまたは7桁未満なら何もしない
            if (!newZip || newZip.length !== 7) return;
            if (isNaN(Number(newZip))) return;

            // 住所検索
            await this.patientAddressSearch(index, newZip);

            // 検索後に住所欄へフォーカス
            this.$nextTick(() => {
              var address1 = document.getElementById(`address1_${index}`);
              address1.focus();
            });
          }
        );
      });
    },
    getOwnOrganizationList: function() {
      // Web Api Call
      
      let _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getHolterJudgmentFlagPOST({
            body:{
              orgId: _this.userInfo.belongsId,
            }
          });
        },
        function(result) {
          _this.reqParams.holterJudgmentFlg = result.obj.holterJudgmentFlg;

          // 見積りコードが紐づいた検査期間を取得・設定
          _this.getChoicesListLinkedEstimate()
        },
        function(result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result);
          
          // 見積りコードが紐づいた検査期間を取得・設定
          _this.getChoicesListLinkedEstimate()
        },
      );
    }
  },
  data() {
    let inspectionPurposeList = this.getChoiceList(choicesType.holterInspectionPurpose, false);
    let analysisOptionList = this.getChoiceList(choicesType.holterAnalysisOp, false);
    let inspectionPeriodList = this.getChoiceList(choicesType.holterInspectionPeriod, false);
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let roleId = userInfo.roleId;
    let userId = userInfo.id;
    let miniday = new Date()
    let maxDate = new Date()
    maxDate.setDate(maxDate.getDate() + 365);
    let maxday = new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
    let isDealer = roleId == role.role_dealer;
    let isSalesOffice = roleId == role.role_salesOffice;
    let isHospital = roleId == role.role_hospital;
    let isHonsha = roleId == role.role_headOffice;
    let isAdmin = roleId == role.role_admin;
    var serviceId = service.holter;

    // 継続申請/転院紹介
    var preReceiptNumber = this.$route.params["receiptNumber"];
    var preKind = this.$route.params["kind"];
    var introduction = this.$route.params["introduction"];
    return {
      atLaunchHidden: atLaunchHidden,
      role: role,
      roleId: roleId,
      userId: userId,
      userInfo: userInfo,
      choicesType:choicesType,
      extUserStatus: extUserStatus,
      belongsId:userInfo.belongsId,
      lendingPeriod:LendingPeriod.period,
      organizationModalActive: false,
      isChecked: false,
      agreement: "",
      activeStep: 0,
      isHospitalAgree: roleId != role.role_dealer,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      miniday: miniday,
      maxday:maxday,
      disabledDays: [],
      reqParams: {
        isDealer: isDealer,
        hospitalName: isHospital ? userInfo.medicalInstitutionName + " " + userInfo.departmentName : "",
        doctorName: "",
        clerkName:"",
        isResultMailSend:false,
        hospitalMail:"",
        zip:isHospital ? userInfo.postcode : "",
        address:isHospital ? userInfo.prefecture + " " + userInfo.city : "",
        address1:isHospital ? userInfo.address : "",
        address2:isHospital ? userInfo.building : "",
        receiverName:"",
        phoneNumber:isHospital ? userInfo.phoneNumber : "",
        desiredDeliveryTimeZone:"",
        resultZip:"",
        resultAddress:"",
        resultBuildingName:"",
        resultCompanyName:"",
        resultDivision:"",
        resultReceiverName:"",
        resultPhoneNumber:"",
        model:"301",
        delivaryTarget:"home",
        leadWireAdapter:false,
        demo:false,
        returnDate:"",
        shippingDate:null,
        deliverySlip:false,
        institutionId: "",
        patientsData: [{ ...InitialPatientValue }],
        memo: "",
        hstModel:"",
        hstReturnDate:"",
        hstShippingDate:null,
        analysisOption:"1",
        inspectionPeriod:"",
        judgmentFlag:false,
        judgment:false,
        hstRequestFlag: false,
        isRequest: true,
      },
      compleateFlg:false,
      searchTargetPostCode:"",
      searchTargetAddress:null,
      requestDate:"",
      receiptNumber:"",
      hstRequestDate:"",
      hstReceptionNumber:"",
      renderKey:true,
      officeCalenderActive: false,
      hstOfficeCalenderActive: false,
      needAgree: roleId == role.role_hospital || roleId == role.role_dealer,
      canAgree:false,
      consentStatement:consentStatement,
      modelList:[],
      desiredDeliveryTimeZoneList:[],
      prevHstSearchParam:{
        kind:"holter",
        belongsId:userInfo.belongsId,
        institutionId:0,
        fullFlag:false
      },
      isHospital,
      analysisOption:analysisOption,
      hstModelList:[],
      hstModelListLinkedEstimate:[],
      inspectionPurposeList:[],
      analysisOptionList:[],
      inspectionPeriodList:[],
      inspectionPeriodListLinkedEstimate:[],
      hstEarliestShippingDate: "",
      holterEarliestShippingDate: "",
      earliestShippingDate: "",
      // 半角数字エラーメッセージ表示
      invalidShippingPostcode: false,
      invalidShippingPhoneNumber: false,
      invalidDeliveryPostcode: false,
      invalidDeliveryPhoneNumber: false,
      note:"",
      // template message
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
      serviceId,
      preReceiptNumber,
      preKind,
      introduction,
      isApplicationValid: false,
      digitErrorZipMessage,
      digitErrorPostcode:false,
      digitErrorResultPostcode:false,
      isInitialZip:false,
      isInitialResultZip:false,
    };
  },
  computed: {
    modifiedReqParams() {
      const reqParams = {
        ...this.reqParams
      };

      const inspectionPeriod = Number(reqParams.inspectionPeriod);

      const tempInspectionPeriodList = this.getChoiceList(this.choicesType.holterInspectionPeriod, false).concat(this.getChoiceList(this.choicesType.holterInspectionPeriodJudgment, false));

      // inspectionPeriod と一致する label3 を持つ選択肢を取得
      const matchedItem = tempInspectionPeriodList.find(
        (item) => Number(item.label3) === inspectionPeriod,
      );
      
      // 選択肢の label1 に「判定医付」が含まれている場合は true、それ以外は false
      reqParams.holterJudgmentFlg = matchedItem && matchedItem.label1 && matchedItem.label1.indexOf('判定医付') !== -1;

      // 検査期間をHolter判定用の値に変換
      if (reqParams.holterJudgmentFlg) {
        reqParams.inspectionPeriod = this.getChoiceList(choicesType.holterInspectionPeriodJudgment,true).find(item => Number(item.label3) === inspectionPeriod).value;
      }

      return reqParams;
    }
  },
  filters: {
    getNameFilter: function(val, list){
      let target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    organizationSelectModal:OrganizationSelectModal,
    facilitySelectModal:FacilitySelectModal,
    holterRequestDetail: holterRequest,
    officeCalenderModal:OfficeCalenderModal
  },
  async mounted() {
    let _this = this
    await this.getBusinessDayPOST(null, 2, function(result) {
      _this.miniday = new Date(result.obj.date)
    })
    // 機種の初期値が「301」に固定されているため機種変更時の処理を初動で実施
    this.changeModel();

    //同意文取得
    await this.getAgreementStr();
    // マスタ取得
    await this.getChoicesList();

    if(this.isHospital){
      this.getOwnOrganizationList()
      if(this.preReceiptNumber) {
      	await this.getApplication();
      } else {
        // 前回申込み情報の取得
        await this.getPreviousApplication()
      }
    }
    this.setupZipWatchers();
  },
  watch: {
    "reqParams.patientsData": {
      handler(newValue) {
        newValue.map((value) => {
          value.invalidPatientPostcode = isNaN(Number(value.zip));
          value.invalidPatientPhoneNumber = isNaN(Number(value.phoneNumber));
        });
      },
      deep: true,
    },
    "reqParams.zip"(newValue) {
      this.invalidShippingPostcode = isNaN(Number(newValue));
      // QA476 郵便番号自動検索処理
      if (this.isInitialZip) {
        this.isInitialZip = false;
        return
      }
      if (!this.invalidShippingPostcode && newValue.length === 7) {
        this.addressSearch('device', newValue);
      }
    },
    "reqParams.phoneNumber"(newValue) {
      this.invalidShippingPhoneNumber = isNaN(Number(newValue));
    },
    "reqParams.resultZip"(newValue) {
      this.invalidDeliveryPostcode = isNaN(Number(newValue));
      // QA476 郵便番号自動検索処理
      if (this.isInitialResultZip) {
        this.isInitialResultZip = false;
        return
      }
      if (!this.invalidDeliveryPostcode && newValue.length === 7) {
        this.addressSearch('result', newValue);
      }
    },
    "reqParams.resultPhoneNumber"(newValue) {
      this.invalidDeliveryPhoneNumber = isNaN(Number(newValue));
    },
  },
};
</script>

<style>
</style>
<style lang="scss" scoped>
.shippingDate {
  width: 150px  !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/HolterRequest.vue